const SettingsKeys = Object.freeze({
  AVAILABLE_LANGUAGES: 'available_languages',
  DEFAULT_LANGUAGE: 'default_language',
  DEFAULT_COUNTRY: 'default_country',
  FAVORITES_COUNTRIES: 'favorites_countries',
  DEATH_PLACE_TYPES: 'death_place_types',
  LANDING_PAGE: 'landing_page',
  DEFAULT_CURRENCY: 'default_currency',
  BODY_RAISING_PLACE_TYPES: 'body_raising_place_types',
  BURIAL_PLACE_TYPES: 'burial_place_types',
  CEREMONY_PLACE_TYPES: 'ceremony_place_types',
  COFFIN_PLACING_PLACE_TYPE: 'coffin_placing_place_type',
  COFFIN_CLOSING_PLACE_TYPE: 'coffin_closing_place_type',
  COFFIN_THANATO_PLACE_TYPE: 'coffin_thanato_place_type',
  THANATO_PLACE_TYPE: 'thanato_place_type',
  REUNION_PLACE_TYPE: 'reunion_place_type',
  VISIT_PLACE_TYPE: 'visit_place_type',
  WAKE_PLACE_TYPES: 'wake_place_types',
  DEATH_LOCATION_PLACE_TYPE: 'death_location_place_type',
  LANGUAGES: 'languages',
  DATE_FORMAT: 'date_format',
  VAT_RATES: 'vat_rates',
  PRICE_ENCODING_TYPE: 'price_encoding_type',
  COMMISSION_NOTE_MODE: 'commission_note_mode',
  COMMISSION_NOTE_PERIODICITY: 'commission_note_periodicity',
  COMMISSION_TRIGGER: 'commission_trigger',
  INVOICING_COLUMNS: 'invoicing_columns',
  THIRD_PARTY_COST_COLUMNS: 'third_party_cost_columns'
})

export default SettingsKeys
